import React, { useContext, useEffect, useState } from 'react';
import BreadCrumb from 'Common/BreadCrumb';
import { useNavigate } from 'react-router-dom';
import { getDashboardData, getMonthlyOrderCounts, getOrders, getTotalOrderCounts } from 'helpers/backend_helper';
import moment from 'moment';
import CountUp from 'react-countup';
import { Boxes } from 'lucide-react';
import { useAppContext } from "context/AppContext";



// Define types for our components
type CountBoxProps = {
    title: string;
    count: number;
    // bgColor: string;
    // textColor: string;
    color?: string;
    icon?: string;
};

type ListBoxProps = {
    title: string;
    items: string[];
};

const Ecommerce = () => {

    const navigate = useNavigate();
    const [totalOrderCounts, setTotalOrderCounts] = useState<any>({} as any);
    const [monthlyOrderCounts, setMonthlyOrderCounts] = useState<number[]>([]);
    const [totalOrders, setTotalOrders] = useState<any>([]);
    const { user } = useAppContext();
  const [taskData, setTaskData] = useState<any>();
  const [show, setShow] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);

    // Define interface for our counts data
    interface DashboardCounts {
        totalTasks: number;
        pendingTasks: number;
        inProgressTasks: number;
        overdueTasks: number;
        assignedToMe: number;
        openWorkOrders: number;
        closedWorkOrders: number;
        inProgressWorkOrders: number;
        onHoldWorkOrders: number;
        pestControlRequests: number;
        myTasks: any[];
    }

    const [dashboardData, setDashboardData] = useState<DashboardCounts>();

    // Sample data with proper typing
    const counts: DashboardCounts = {
        totalTasks: 124,
        pendingTasks: 42,
        inProgressTasks: 33,
        overdueTasks: 10,
        assignedToMe: 15,
        openWorkOrders: 28,
        closedWorkOrders: 76,
        inProgressWorkOrders: 19,
        onHoldWorkOrders: 8,
        pestControlRequests: 23,
        myTasks: []
    };

    useEffect(() => navigate("/dashboard"), [navigate]);

    useEffect(() => {
        //onGetDashboardItems();
        console.log('on dashboard');
        onGetDashboardData();
    }, []);


    const onGetDashboardData = async () => {

        try {
            const response = await getDashboardData(user?.userId || 0);

            console.log(response);
            setDashboardData(response.data[0]);
        } catch (error) {

        }
    }


      // Update Data
  const handleEditDataClick = (ele: any) => {
    console.log('ele', ele)
    setTaskData({ ...ele });
    setIsEdit(true);
    setShow(true);
  };
  
  const toggle = () => setShow(!show);
  
  const onSave = (result: any) => {
    console.log('result', result)
  }


    const onGetDashboardItems = async () => {

        try {
            const response = await getOrders();
            const orderHistory = response.data.sort((a: any, b: any) => (a.updatedAt > b.updatedAt ? -1 : 1));
            setTotalOrders(orderHistory);
            console.log(orderHistory);
        } catch (error) {

        }


        // load total order count
        try {
            const responseTotalOrders = await getTotalOrderCounts();
            console.log(responseTotalOrders);
            var orderCounts = {} as any;

            orderCounts.newOrders = responseTotalOrders.data.find(p => p.status === 'Order Placed')?.ordercount;
            let deliveredOrders = responseTotalOrders.data.find(p => p.status === 'Order Delivered')?.ordercount;
            let completedOrders = responseTotalOrders.data.find(p => p.status === 'Order Completed')?.ordercount;
            orderCounts.deliveredOrders = parseInt(deliveredOrders || 0) + parseInt(completedOrders || 0);
            orderCounts.pendingOrders = responseTotalOrders.data.find(p => p.status === 'Order Processing')?.ordercount;
            orderCounts.shippedOrders = responseTotalOrders.data.find(p => p.status === 'Order Shipped')?.ordercount;

            const sum = responseTotalOrders.data.reduce((accumulator, object) => {
                return parseInt(accumulator) + parseInt(object.ordercount);
            }, 0);

            orderCounts.totalOrders = sum;
            setTotalOrderCounts(orderCounts);
        } catch (error) {

        }


        // monthly order counts
        // load total order count

        try {
            const responseMonthlyOrdes = await getMonthlyOrderCounts();

            let monthsCount = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
            console.log(responseMonthlyOrdes)

            responseMonthlyOrdes.data.forEach((element: any) => {
                var momentDate = moment(element.month)

                const month = momentDate.month();
                monthsCount[month - 1] = parseInt(element.orderCount);
            });

            setMonthlyOrderCounts(monthsCount);
            console.log(monthsCount);

        } catch (error) {

        }

    }


    // Reusable Count Box Component with TypeScript
    const CountBox: React.FC<CountBoxProps> = ({ title, count, color }) => {
        return (
            //   <div className={`${bgColor} p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow`}>
            //     <h3 className="text-lg font-medium text-gray-600">{title}</h3>
            //     <p className={`${textColor} text-3xl font-bold mt-2`}>{count}</p>
            //   </div>

            <div className="2xl:col-span-3 2xl:row-span-1 md:col-span-2 md:row-span-1">
                <div className="card">
                    <div className="flex items-center gap-3 card-body">
                        <div className={`flex items-center justify-center size-12 rounded-md text-15 bg-${color}-100 text-${color}-500 dark:bg-custom-500/20 shrink-0`}>
                            <Boxes />
                        </div>
                        <div className="grow">
                            <h5 className="mb-1 text-16">
                                <CountUp end={count || 0} separator="," className="counter-value" />
                            </h5>
                            <p className="text-slate-500 dark:text-zink-200">{title}</p>
                        </div>
                    </div>
                </div>
            </div>

        );
    };

    // Reusable List Box Component with TypeScript
    const ListBox: React.FC<ListBoxProps> = ({ title, items }) => {
        return (
            <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
                <h3 className="text-lg font-medium text-gray-700 mb-3">{title}</h3>
                <ul className="space-y-2">
                    {items.map((item, index) => (
                        <li key={index} className="flex items-center">
                            <span className="w-2 h-2 bg-gray-400 rounded-full mr-2"></span>
                            <span className="text-gray-600">{item}</span>
                        </li>
                    ))}
                </ul>
            </div>
        );
    }


    return (
        <React.Fragment>
            {/* <BreadCrumb title='Ecommerce' pageTitle='Dashboards' /> */}
            <br />
            {/* <ProductsOrders  /> */}
            <div >
                {/* <WelcomeWidget />
                <OrderStatistics /> */}
                {/* <Widgets data={totalOrderCounts} />
                {/* <SalesRevenue /> 
                <div className="order-last md:col-span-2 2xl:col-span-12 2xl:row-span-3 card 2xl:order-none">
                    <div className="card-body">
                        <h6 className="mb-4 text-gray-800 text-15 dark:text-zink-50">Orders Overview</h6>
                        <OrdersOverviewChart id="ordersOverview" data={monthlyOrderCounts} />
                    </div>
                </div> */}

                {/* <TrafficResources /> */}

                {/* <CustomerService />
                <SalesMonth />
                <TopSellingProducts />
                <Audience /> */}

                <div >
                    {/* Task Counts */}
                    <div className="grid grid-cols-1 gap-x-5 md:grid-cols-12 2xl:grid-cols-12">

                      
                    </div>

                    <div id="myTask" className="order-last md:col-span-8 2xl:col-span-8 2xl:row-span-2  md:row-span-2 card 2xl:order-none  md:order-none pb-3">
                        <h6 className="pl-5 pt-5 text-gray-800 text-15 dark:text-zink-50">Welome to Good Luck Admin Panel</h6>
                        <div className="card-body overflow-y-auto max-h-64">
                            {dashboardData?.myTasks.map((task, index) => (
                                <div key={'task-' + index} className={index % 2 === 0 ? 'bg-custom-50' : 'bg-white'}>
                                    <p className="mb-0 text-gray-800 text-15 dark:text-zink-50 p-1 cursor-pointer" onClick={() => handleEditDataClick(task)}>{task.name}</p>
                                </div>
                            ))}
                        </div>
                    </div>

                 

                </div>

                {/* Task Lists Section */}
                {/* <div className="mt-10">
                    <h2 className="text-xl font-semibold text-gray-700 mb-4">Task Lists</h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <ListBox title="Task Lists" items={['High Priority', 'Medium Priority', 'Low Priority']} />
                        <ListBox title="Pest Control Requests List" items={['Pending', 'Assigned', 'Completed']} />
                        <ListBox title="Work Orders Lists" items={['New', 'In Progress', 'Completed', 'Cancelled']} />
                    </div>
                </div> */}
            </div>
        
        </React.Fragment>
    );
};

export default Ecommerce;
